// extracted by mini-css-extract-plugin
export default {"FiltroWrapper":"styles_FiltroWrapper__k4osT"};